import React from "react";
import { DialogContentText, DialogActions } from "@mui/material";
import BIButton from "../common/Button/index";

const SessionClosedNotification = ({
  dispatch,
  setDialog,
  logOut,
  navigate,
}) => {
  const handleAccept = () => {
    try {
      dispatch(setDialog(false, "sm", "", <></>, "body"));

      logOut();

      navigate("/");
    } catch (error) {
      console.error("Error durante el logout:", error);
      navigate("/");
    }
  };

  return (
    <>
      <DialogContentText>
        <p>
          Tu sesión ha sido cerrada automáticamente por inactividad por motivos
          de seguridad.
        </p>
        <p>Para continuar, por favor inicia sesión nuevamente.</p>
      </DialogContentText>

      <DialogActions sx={{ marginTop: "1rem" }}>
        <BIButton variant="contained" color="primary" onClick={handleAccept}>
          Aceptar
        </BIButton>
      </DialogActions>
    </>
  );
};

export default SessionClosedNotification;
